export const samePaths = (path1?: string, path2?: string) => {
    const path1Rep = (path1 || '').replace(/\/$/, '');
    const path2Rep = (path2 || '').replace(/\/$/, '');
    return path1Rep === path2Rep;
};
